import { PropsWithChildren } from "react";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import Button, { ButtonVariants } from "shared/UI/Buttons/Button";

export type CardWithButtonProps = PropsWithChildren & {
  buttonText: string;
  handleClick: Function;
  className?: string;
  buttonVariant?: ButtonVariants;
};

export const CardWithButton = ({ buttonVariant, className, buttonText, handleClick, children }: CardWithButtonProps) => {
  return (
    <RoundedCard className={className}>
      {children}
      <Button
        className="mt-6"
        variant={buttonVariant}
        text={buttonText}
        aria-label={buttonText}
        onClick={() => handleClick()}
      />
    </RoundedCard>
  );
};

CardWithButton.defaultProps = { showChevron: false, title: "" };
